module.exports = __webpack_public_path__ + "static/media/woman_using_laptop.3ea766fe.png";